import { Component, OnInit } from '@angular/core';
import { IControlNameBody, ILanguageTranslation } from '../../../../../core/models';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { KawneerAdminService } from '../../../../../core/services/kawneer-admin.service';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { NotifyType } from '../../../../../core/enums/NotifyType';
import { EMPTY } from 'rxjs';
import { LanguageTranslationService } from '../../../../../core/services/language-translation.service';
@Component({
  selector: 'app-language-translation',
  templateUrl: './language-translation.component.html',
  styleUrls: ['./language-translation.component.scss']
})
export class LanguageTranslationComponent implements OnInit {

  //#region member variable
  languageTranslationGridView: GridDataResult;
  public gridData: ILanguageTranslation[] = [];
  languageTranslationLoading: boolean;
  saveInProgress: boolean;
  constructor(private kawneerAdmin: KawneerAdminService, private appNotifyService: AppNotifyService, private languageTranslation: LanguageTranslationService) { }

  ngOnInit() {
    this.loadGridData();
  }
  loadGridData() {
    this.languageTranslationLoading = true;
    let languageCode = localStorage.getItem('language');
    this.kawneerAdmin.getLanguageTranslation(languageCode).subscribe((response: any) => {
      console.log(response);
      this.gridData = response;
      this.loadLanguageTranslationGrid();
      this.languageTranslationLoading = false;

    });
  }
  //#region label declaration
  languageTranslationLabel = {
    componentName: "Component Name",
    languageCode: "Language Code",
    controlName: "Control Name",
    controlText: "Control Text"
  }
  //#endregion
  //#region Grid data binding
  public loadLanguageTranslationGrid() {
    this.languageTranslationGridView = process(this.gridData, this.languageTranslationGridstate);
  }
  //#endregion
  //#region sorting,filtering,pagination of grid
  public languageTranslationGridstate: State = {
    sort: [],
    skip: 0,
    take: 10,
    group: [],
    filter: null,
  };
  public languageTranslationGridSortChange(sort): void {
    this.languageTranslationGridstate.sort = sort;
    this.loadLanguageTranslationGrid();
  }
  public languageTranslationGridPageChange({ skip, take }: PageChangeEvent): void {
    this.languageTranslationGridstate.skip = skip;
    this.languageTranslationGridstate.take = take;
    this.loadLanguageTranslationGrid();

  }
  public languageTranslationDataStateChange(state: DataStateChangeEvent): void {
    this.languageTranslationGridstate = state;
    this.loadLanguageTranslationGrid();
  }

  //#endregion
  //#region save new control name operations
  public newArrayList: any = [];
  controlNameLeave($event, dataItem) {
    let controlTextData = $event.target.value;
    if (controlTextData) {
      var rowData = this.gridData.find(r => (r.controlText == controlTextData && r.componentName == dataItem.componentName));
      if (rowData) {
        dataItem.isUpdated = false;       
      } else {       
        dataItem.controlText = controlTextData;
        dataItem.isUpdated = true;
      }
    }

    console.log(dataItem);
  }
  saveControlName() {
    if (this.gridData.length > 0) {
      this.saveInProgress = true;
      for (let i = 0; i < this.gridData.length; i++) {
        if (this.gridData[i].isUpdated == true) {
          this.newArrayList.push(this.gridData[i]);
        }
      }
      if (this.newArrayList.length>0) {
        const body: IControlNameBody = {
          controlTextList: this.newArrayList
        }
        this.kawneerAdmin.saveControlName(body).subscribe((response: any) => {
          for (let i = 0; i < this.gridData.length; i++) {
            this.gridData[i].isUpdated = false
          }
          this.saveInProgress = false;
          this.appNotifyService.notify(NotifyType.SUCCESS, 'Saved Successfully');
          this.newArrayList = [];
          this.updateLanguageDataInLocalstorage();
          this.loadGridData();
        });
      } else {
        this.appNotifyService.notify(NotifyType.INFO, 'Please modify the data to save');
        this.saveInProgress = false;

      }
     
    }
  }
  //#endregion
  //#region update language data in localstorage  
  updateLanguageDataInLocalstorage() {
    const id = localStorage.getItem('language');
    const body = {
      languageCode: id
    }
    this.languageTranslation.getLanguageLabel(body).subscribe(response => {
      if (response) {
        localStorage.removeItem('LanguageTextV2');
        localStorage.setItem('LanguageTextV2', JSON.stringify(response));          
        }
    })
  }
  //#endregion
}
